import useAppData from './useAppData';

export default useAppData;
